import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { Service } from '../models/service';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ServiceDataService } from '../service/service-data.service';

@Component({
  selector: 'app-service-detail',  
  templateUrl: './service-detail.component.html',
  styleUrls: ['./service-detail.component.scss']
})
export class ServiceDetailComponent implements OnInit {

  constructor(private dataService: ServiceDataService) { }

  ngOnInit(): void {
    this.editForm = this.createFormGroup();
  }

  public active = false;
  public editForm: FormGroup;

  @Input() public isNew = false;

  @Input() public set model(service: Service) {
      this.editForm = this.createFormGroup();
      this.editForm.reset(service);

      if (service && service.IsLocked === true) {
        this.editForm.disable();
      }

      this.active = service !== undefined;
  }

  @Output() cancel: EventEmitter<any> = new EventEmitter();
  @Output() save: EventEmitter<Service> = new EventEmitter();

  private createFormGroup() : FormGroup {
    return new FormGroup({
      Id: new FormControl(0),
      IsLocked: new FormControl({value: '', disabled: true}),
      Code: new FormControl('', {updateOn: 'blur', validators: [Validators.required, Validators.minLength(3), Validators.maxLength(25), Validators.pattern('^[0-9a-zA-Z\._\-]*$')], asyncValidators: [this.UniqueCode.bind(this)]}),
      Name: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(50), Validators.pattern('^[0-9a-zA-Z \.:_\-]*$')]),
      Description: new FormControl('', [Validators.maxLength(200), Validators.pattern('^[0-9a-zA-Z\r\n \.:;_\-]*$')])
    });
  }

  public onSave(e): void {
      e.preventDefault();
      let svc : Service = this.editForm.value;
      if (!svc.Id)
        svc.Id = 0;
      this.save.emit(svc);
      this.active = false;
  }

  public onCancel(e): void {
      e.preventDefault();
      this.closeForm();
  }

  public closeForm(): void {
      this.active = false;
      this.cancel.emit();
  }
  
  UniqueCode(ctl: AbstractControl) : Observable<ValidationErrors | null> {
    if (ctl.pristine)
      return of(null);

    let idCtl = ctl.parent.controls['Id'];

    return this.dataService.serviceCount(+idCtl.value, ctl.value)
    .pipe(
      map(
        r => 
        +r["@odata.count"] > 0 ? { unique: true } : null),
      catchError(() => of(null))
    );
  }  
}
